export interface BonusesSlice {
    activeBet: string
    setActiveBet: (activeBet: string) => void
    totalWin: string
    setTotalWin: (totalWin: string) => void
    hasActiveBonusEnded?: boolean
    setHasActiveBonusEnded: (hasEnded: boolean) => void
    bonusSystemState: string
    setBonusSystemState: (state: string) => void
    bonusSystemDeclineState: string
    setBonusSystemDeclineState: (state: string) => void
    declinedBonusesIds: string[]
    setDeclinedBonusesIds: (id: string) => void
    isWaitingForBonusSystemResponse: boolean
    setIsWaitingForBonusSystemResponse: (isWaitingForBonusSystemResponse: boolean) => void
}

export const createBonusesSlice = (
    set: (fn: (state: BonusesSlice) => Partial<BonusesSlice>) => void
): BonusesSlice => ({
    isWaitingForBonusSystemResponse: false,
    setIsWaitingForBonusSystemResponse: (isWaitingForBonusSystemResponse: boolean) => {
        set(() => ({ isWaitingForBonusSystemResponse }))
    },
    hasActiveBonusEnded: undefined,
    setHasActiveBonusEnded: (hasActiveBonusEnded: boolean) => {
        set(() => ({ hasActiveBonusEnded }))
    },
    activeBet: '',
    setActiveBet: (activeBet: string) => {
        set(() => ({ activeBet }))
    },
    totalWin: '',
    setTotalWin: (totalWin: string) => {
        set(() => ({ totalWin }))
    },
    bonusSystemState: '',
    setBonusSystemState: (state: string) => {
        set(() => ({ bonusSystemState: state }))
    },
    bonusSystemDeclineState: '',
    setBonusSystemDeclineState: (state: string) => {
        set(() => ({ bonusSystemDeclineState: state }))
    },
    declinedBonusesIds: [],
    setDeclinedBonusesIds: (id: string) => {
        set((state) => ({
            declinedBonusesIds: [...state.declinedBonusesIds, id],
        }))
    },
})
